import { useSet } from 'react-use';

export default function useEntitySet<T>(initialValue?: T[]) {
  const [selectedItemsSet, { has, toggle, reset }] = useSet(new Set(initialValue));

  return {
    selectedItemsSet,
    has,
    toggle,
    reset,
  };
}
